export default {
  VISIT: 1,
  TELEPHONE: 2,
  EMAIL: 3,
  WHATSAPP: 4,
  SMS: 5,
  VIDEO_CONFERENCE: 6
}
